export const getSound = state => state.sound;
export const getMute = state => getSound(state).mute;



// WEBPACK FOOTER //
// ./src/reducers/sound/selectors.js